import React, { memo, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import {useSelector} from 'react-redux';
import { isNormalZhEnCss } from '../../utils';
import SrollAnimtion from '../SrollAnimtion';
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from './styles.module.scss';


// install Swiper modules
const Index = memo(() => {
  const { home:{aboveTheFoldList}, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  const [ activeIndex, setActiveIndex ] = useState(0);
  // 样式判断
  const normal = () => {
    return isNormalZhEnCss(lang, 'English') ? styles.normalen : styles.normalcn;
  };

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    let interleaveOffset = 0.5; //视差比值
    return (
      <Swiper
        initialSlide={activeIndex}
        direction={'horizontal'}
        className="aboveTheFoldSwiper"
        modules={[Autoplay, Navigation]}
        pagination={{
          clickable: false, // 打开自定义按钮控制事件上一个和下一个
        }}
        spaceBetween={0}
        centeredSlides={true}
        navigation = {{
          prevEl: '.btnPrevPage',
          nextEl: '.btnNextPage',
        }}
        effect="cube"
        speed={1000}
        aria-grabbed
        watchSlidesProgress
        mousewheel
        keyboard
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        onInit={(swiper) => {
          setActiveIndex(swiper.activeIndex);
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
        }}
        onTouchStart={(swiper) => {
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = '';
          }
        }}
        onSetTransition={(swiper, speed) => {
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + 'ms';
          }
        }}
      >
        {
          aboveTheFoldList.map(item => {
            return (
              <SwiperSlide key={item.id} style={{ background: `url(${item.img}) no-repeat 100% 100% / cover`}}>
                {/* <img src={item.img} /> */}
                <div className="title" data-swiper-parallax="-300">
                  {item.title}
                </div>
                <div className="subtitle" data-swiper-parallax="-200">
                  {item.desc}
                </div>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    );
  };

  const activeIndexNum = activeIndex+1;
  return (
      <div className={normal()}>
        {desktopMobile()}
        <div className='paginations'>
          <div className='btns'>
            <a className='btnPrevPage' style={{opacity: activeIndex === 0  ? 0.2 : 1}}>
            <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="M30.5 17L18.5 26L30.5 35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="-1" y="1" width="50" height="50" rx="25" transform="matrix(-1 0 0 1 50 0)" stroke="white" strokeWidth="2"/>
              </g>
            </svg>
            </a>
            <a className='btnNextPage' style={{opacity: aboveTheFoldList.length === activeIndexNum ? 0.2 : 1}}>
              <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.5 17L33.5 26L21.5 35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="1" y="1" width="50" height="50" rx="25" stroke="white" strokeWidth="2"/>
              </svg>
            </a>
          </div>
          <div className='total'><span>{activeIndexNum}/{aboveTheFoldList.length}</span></div>
        </div>
        <SrollAnimtion />
      </div>
  );
});
export default Index;
